package blazern.lexisoup.core.ui.theme

import androidx.compose.material3.ColorScheme

@androidx.compose.runtime.Composable
actual fun getPlatformColorScheme(darkTheme: Boolean): ColorScheme? = null
